<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import isEmpty from 'lodash.isempty'

export default {
    name: 'BrandHero',

    components: { ImageWrapper },

    props: {
        brand: {
            type: Object,
            default: undefined,
        },
        photo: {
            type: String,
            default: null,
        },
        storeCount: {
            type: Number,
            default: 0,
        },
    },

    computed: {
        address() {
            return this.$store.getters['order/address']
        },
        hasAddress() {
            return !isEmpty(this.address)
        },
        // Same label as the header bar: a saved address's name, else the full address.
        addressLabel() {
            return this.address.name || this.address.full_address || ''
        },
        // First two brand tags + "N stores", non-empty segments only (spec B3).
        tagLabel() {
            const tags = (this.brand.tags || []).slice(0, 2)
            const stores =
                this.storeCount > 0
                    ? this.$t('brand.stores_count', { count: this.storeCount }, this.storeCount)
                    : null
            return [...tags, stores].filter(Boolean).join(' · ')
        },
    },

    methods: {
        // The header bar's picker logic (DeliveryDetails.vue).
        openAddress() {
            if (this.$user.isLoggedIn && this.$addresses.total) this.$location.select.open()
            else this.$location.enter.open()
        },
    },
}
</script>

<template lang="pug">
section.brand-hero(v-if="brand")
    .container
        .brand-hero-grid
            .brand-hero-content
                .brand-hero-logo-row
                    image-wrapper.brand-hero-logo(:src="brand.logo" rounded contain width="56px" height="56px")
                    span.brand-hero-label(v-if="tagLabel") {{ tagLabel }}
                h1.brand-hero-title
                    | {{ brand.name }}
                    br
                    span.brand-hero-title-highlight {{ $t('brand.hero_tagline') }}
                p.brand-hero-text(v-if="brand.description") {{ brand.description }}
                button.brand-hero-address(type="button" @click="openAddress")
                    icon.brand-hero-address-icon(icon="fa-solid fa-location-dot")
                    template(v-if="hasAddress")
                        span.brand-hero-address-lines
                            span.brand-hero-address-caption {{ $t('brand.delivering_to') }}
                            span.brand-hero-address-value {{ addressLabel }}
                        span.brand-hero-address-button {{ $t('brand.change_address') }}
                    template(v-else)
                        span.brand-hero-address-value.brand-hero-address-placeholder {{ $t('brand.enter_address') }}
                        span.brand-hero-address-button {{ $t('brand.search') }}
                .brand-hero-divider
                    span.brand-hero-divider-line
                    span.brand-hero-divider-text {{ $t('brand.or') }}
                    span.brand-hero-divider-line
                router-link.brand-hero-cta(:to="{name: 'restaurant-list'}")
                    | {{ $t('brand.to_restaurants') }}
                    icon.ml-2(icon="fa-solid fa-arrow-right")
            .brand-hero-photo-col
                img.brand-hero-photo(v-if="photo" :src="photo" alt="")
</template>
